import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Stack } from "@mui/material";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/th";
import DataTableLayout from "layouts/DatatableLayout";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { allSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { getReportSaleVisitAndReserveBySale } from "../../redux/handlers/report/getReportSaleVisitAndReserveBySale.handler";
export function ReportSaleVisitAndReserveBySale() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var _useState = _sliced_to_array(useState(null), 2), startMonth = _useState[0], setStartMonth = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), endMonth = _useState1[0], setEndMonth = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), saleId = _useState2[0], setSaleId = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionSale = _useState3[0], setOptionSale = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        months: [],
        data: []
    }), 2), reportData = _useState4[0], setReportData = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), hasSearched = _useState5[0], setHasSearched = _useState5[1];
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    var getReportSaleVisitAndReserveBySaleReducer = useAppSelector(function(state) {
        return state.getReportSaleVisitAndReserveBySaleReducer;
    });
    var canSearch = Boolean(startMonth && endMonth && saleId);
    useEffect(function() {
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(allSetUserReducer.isFetching || getReportSaleVisitAndReserveBySaleReducer.isFetching);
        if (allSetUserReducer.data) {
            var sales = allSetUserReducer.data.data.filter(function(item) {
                return item.sys_user_role_id === 3;
            }).map(function(item) {
                return {
                    value: item.sys_user_id,
                    label: item.sys_user_fullname
                };
            });
            setOptionSale(Array.from(new Map(sales.map(function(item) {
                return [
                    item.value,
                    item
                ];
            })).values()));
        }
        if (getReportSaleVisitAndReserveBySaleReducer.data) {
            var _getReportSaleVisitAndReserveBySaleReducer_data;
            var data = ((_getReportSaleVisitAndReserveBySaleReducer_data = getReportSaleVisitAndReserveBySaleReducer.data) === null || _getReportSaleVisitAndReserveBySaleReducer_data === void 0 ? void 0 : _getReportSaleVisitAndReserveBySaleReducer_data.data) || {
                months: [],
                data: []
            };
            setReportData({
                months: (data === null || data === void 0 ? void 0 : data.months) || [],
                data: (data === null || data === void 0 ? void 0 : data.data) || []
            });
        }
    }, [
        allSetUserReducer,
        getReportSaleVisitAndReserveBySaleReducer
    ]);
    useEffect(function() {
        if (!canSearch) {
            setHasSearched(false);
            setReportData({
                months: [],
                data: []
            });
        }
    }, [
        canSearch
    ]);
    var handleSearch = function() {
        if (!canSearch) {
            return;
        }
        setHasSearched(true);
        dispatch(getReportSaleVisitAndReserveBySale({
            smonth: moment(startMonth).format("YYYY-MM"),
            emonth: moment(endMonth).format("YYYY-MM"),
            saleid: parseInt(saleId, 10)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var columns = useMemo(function() {
        var monthColumns = (reportData.months || []).map(function(monthKey) {
            return {
                name: moment(monthKey, "YYYY-MM").locale("th").format("MMM YYYY"),
                minWidth: "180px",
                cell: function(row) {
                    var _row_month_summary;
                    var monthSummary = (row === null || row === void 0 ? void 0 : (_row_month_summary = row.month_summary) === null || _row_month_summary === void 0 ? void 0 : _row_month_summary[monthKey]) || {
                        reserve_count: 0,
                        visit_count: 0
                    };
                    return /*#__PURE__*/ _jsxs(Stack, {
                        direction: "column",
                        spacing: 0.5,
                        sx: {
                            py: 1
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    "ใบจอง: ",
                                    monthSummary.reserve_count
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    "ใบเยี่ยมชม: ",
                                    monthSummary.visit_count
                                ]
                            })
                        ]
                    });
                }
            };
        });
        return [
            {
                name: "ชื่อร้านค้า(สาขา)",
                selector: function(row) {
                    return row.shop_label;
                },
                minWidth: "280px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx("div", {
                        style: {
                            whiteSpace: "normal",
                            padding: "8px 0"
                        },
                        children: row.shop_label || "-"
                    });
                }
            }
        ].concat(_to_consumable_array(monthColumns));
    }, [
        reportData.months
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานเปรียบเทียบใบเยี่ยมชมกับใบจอง แยกตามเซลล์"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานเปรียบเทียบใบเยี่ยมชมกับใบจอง แยกตามเซลล์"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "card-body px-xl-3",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "row gx-xl-4 pb-0",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-3 col-md-6",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1 z-3",
                                                    children: "เดือนเริ่มต้น"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    selected: startMonth,
                                                    onChange: function(date) {
                                                        return setStartMonth(date);
                                                    },
                                                    dateFormat: "yyyy-MM",
                                                    showMonthYearPicker: true,
                                                    className: "form-control px-2 mb-2 input-equal",
                                                    isClearable: true,
                                                    placeholderText: "เลือกเดือนเริ่มต้น",
                                                    maxDate: endMonth
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-3 col-md-6",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1 z-3",
                                                    children: "เดือนสิ้นสุด"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    selected: endMonth,
                                                    onChange: function(date) {
                                                        return setEndMonth(date);
                                                    },
                                                    dateFormat: "yyyy-MM",
                                                    showMonthYearPicker: true,
                                                    className: "form-control px-2 mb-2 input-equal",
                                                    isClearable: true,
                                                    placeholderText: "เลือกเดือนสิ้นสุด",
                                                    minDate: startMonth
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-4 col-md-6",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เซลล์ที่ดูแล"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-3",
                                                    placeholder: "เลือกเซลล์ที่ดูแล",
                                                    options: optionSale,
                                                    value: optionSale.find(function(opt) {
                                                        return opt.value === saleId;
                                                    }) || null,
                                                    onChange: function(option) {
                                                        return setSaleId(option ? option.value : "");
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-2 col-md-6 d-flex align-items-center",
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            className: "btn btn-primary w-100 mb-2",
                                            onClick: handleSearch,
                                            disabled: !canSearch,
                                            children: "ค้นหา"
                                        })
                                    })
                                ]
                            }),
                            !canSearch ? /*#__PURE__*/ _jsx("div", {
                                className: "text-secondary fs-14 mt-2",
                                children: "กรุณาเลือกเดือนเริ่มต้น, เดือนสิ้นสุด และเซลล์ที่ดูแลก่อนค้นหา"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body pt-0 px-0",
                        children: hasSearched ? /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: reportData.data || [],
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "px-3 pb-3 text-secondary",
                            children: "ระบุข้อมูล filter แล้วกดค้นหาเพื่อแสดงรายงาน"
                        })
                    })
                ]
            })
        ]
    });
}
